module.exports = __webpack_public_path__ + "static/media/MR_kanata.45dba1f0.png";